module.exports = __webpack_public_path__ + "img/menu-fx-rate.fdf1bf2c.svg";